import { gsap } from "gsap";

const heroItems = document.querySelectorAll('.hero__item');

if (heroItems.length > 0) {
    gsap.set('.hero__item', {
        autoAlpha: 0,
    });

    gsap.to('.hero__item', {
        autoAlpha: 1,
        duration: 0.0,
        delay: 0.25,
        stagger: {
            each: 0.1,
            from: "random",
        }
    });
}